import getDisplayName from './getDisplayName';
import findElement from './findElement';

export default function isElementOfComponent(
    element,
    nameOrComponent,
    { maxDepth = undefined, diveIntoChildren = true, onlySingleChildren = true } = {},
) {
    const namesOrComponents = Array.isArray(nameOrComponent) ? nameOrComponent : [nameOrComponent];

    const predicate = (item) => {
        const elementDisplayName = getDisplayName(item);

        if (namesOrComponents.length === 0 || !elementDisplayName) return false;

        return namesOrComponents.some((nameOrComponentItem) => {
            const componentDisplayName = getDisplayName(nameOrComponentItem);

            if (nameOrComponentItem instanceof RegExp) {
                return nameOrComponentItem.test(elementDisplayName);
            }
            if (elementDisplayName === componentDisplayName) {
                return true;
            }
            return componentDisplayName.includes(`(${elementDisplayName})`);
        });
    };
    const matchingElement = findElement(element, predicate, {
        maxDepth: diveIntoChildren ? maxDepth : 0,
        onlySingleChildren,
    });

    return !!matchingElement;
}
